import type { AssetTechnicalFormProps } from "./asset-technical-form.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import FormViewer from "@/components/FormEngine/Viewer";

const AssetTechnicalForm = ({
  schema,
  handleChange,
  form,
}: AssetTechnicalFormProps) => {
  const { t } = useTranslation();

  return (
    <FormViewer
      schema={schema}
      formParams={{ form }}
      handleChange={handleChange}
      emptyDescription={
        <Typography.Text>{t("assetType:noTechnicalForm")}</Typography.Text>
      }
    />
  );
};

export default AssetTechnicalForm;
